import commonPostTypeConfig from '../../common/postTypes/language'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'language',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
